// search-from-select-list
// list-select-option

const handleFormSearch = e => {
  const val    = e.target.value
  const parent = e.target.closest('.select-list-popup')
  parent.querySelectorAll('.list-select-option').forEach(el => {
    const listVal         = el.getAttribute('data-value')
    const listLabel       = el.getAttribute('data-label')
    const listDescription = el.getAttribute('data-description')
    const labelUlLi       = el.parentElement

    if (
      listVal.toLowerCase().includes(val.toLowerCase()) ||
      listLabel.toLowerCase().includes(val.toLowerCase()) ||
      listDescription.toLowerCase().includes(val.toLowerCase())
    ) {
      el.classList.remove('d-none')
      // For now, this code unused
      // if (labelUlLi != null) {
      //   labelUlLi.classList.remove('d-none');
      // }
    } else {
      el.classList.add('d-none')
      // For now, this code unused
      // if (labelUlLi != null) {
      //   labelUlLi.classList.add('d-none');
      // }
    }
  })
}

document.querySelectorAll('.search-from-select-list').forEach(el => {
  el.addEventListener('input', handleFormSearch)
  el.addEventListener('change', handleFormSearch)
})
